<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 md-small-size-100">
      <span>
        {{ $t("term.copy_class_from_term", { term: currentTerm.name }) }}
      </span>
    </div>
    <div class="md-layout-item md-size-33 md-small-size-100">
      <validation-field name="destination term">
        <label>{{ $t("term.select_term_to_be_copied") }}</label>
        <md-select
          name="destination term"
          id="target"
          v-model="formData.destination_term_id"
          required
        >
          <md-option
            :value="term.id"
            v-for="(term, termIndex) in termList"
            :key="termIndex"
          >
            {{ term.name }}
          </md-option>
        </md-select>
        <span
          class="md-error"
          style="top: 40px"
          v-if="serverValidations.destination_term_id"
          >{{ serverValidations.destination_term_id }}</span
        >
      </validation-field>
    </div>
    <div class="md-layout-item md-size-100 md-small-size-100">
      <span>{{ $t("term.roll_option") }}</span>
    </div>
    <div class="md-layout-item md-size-100 md-small-size-100">
      <md-radio :value="true" v-model="formData.role_option">{{
        $t("term.close_all_classes")
      }}</md-radio>
      <br />
      <md-radio :value="false" v-model="formData.role_option">{{
        $t("term.clone_class_to_level_up")
      }}</md-radio>
    </div>
    <template v-if="!!formData.role_option">
      <div class="md-layout-item md-size-100 md-small-size-100">
        <span>{{ $t("term.item_that_copy") }}</span>
      </div>
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-checkbox v-model="formData.options.students">{{
          $t("term.include_student")
        }}</md-checkbox>
      </div>
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-checkbox v-model="formData.options.teachers">{{
          $t("term.include_teacher")
        }}</md-checkbox>
      </div>
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-checkbox v-model="formData.options.keep_info_intact"
          >{{ $t("term.keep_infomation") }}
          <md-icon style=""
            >help
            <md-tooltip md-direction="top">{{
              $t("term.close_all_class_detail")
            }}</md-tooltip></md-icon
          >
        </md-checkbox>
      </div>
    </template>
  </div>
</template>
<script>
import { service_paths } from "@/constants/Services";

export default {
  name: "copy-term-form",
  props: ["formData", "currentTerm", "serverValidations"],
  data() {
    return {
      currentPath: service_paths.terms,
      query: {
        page: 0,
        limit: 200
      },
      termList: []
    };
  },
  watch: {
    "formData.destination_term_id": function() {
      this.serverValidations.destination_term_id &&
        delete this.serverValidations.destination_term_id;
    }
  },
  created() {
    this.getTermList();
  },
  methods: {
    getTermList() {
      this.$axios.get(this.currentPath, this.query).then(response => {
        this.termList = response.data.data.filter(
          item => item.id !== this.currentTerm.id
        );
      });
    }
  }
};
</script>
